// extracted by mini-css-extract-plugin
export default {"melodyVideo":"VJ-z","isFullWidth":"WJ-z","landingPageVideo":"XJ-z","play":"YJ-z","iframeVideo":"ZJ-z","playHidden":"_J-z","fullwidth":"aK-z"};